import typeToReducer from 'type-to-reducer';
import get from 'lodash.get';
import capitalize from 'lodash.capitalize';

import { RESET_STORE } from '../../resetStore/actions';

import * as actions from './actions';

const initialState = {
  err: false,
  errMsg: '',
  loading: false,
  subscription: {
    billingCycle: '',
    currentPeriodEnd: 0,
    canceled: false,
  },
  address: {
    city: '',
    country: '',
    line1: '',
    line2: '',
    postalCode: '',
    state: '',
  },
  card: {
    brand: '',
    funding: '',
    country: '',
    expMonth: 0,
    expYear: 0,
    last4: '',
  },
};

export default typeToReducer(
  {
    [actions.GET_BILLING_INFO]: {
      PENDING: (state) => ({
        ...state,
        err: false,
        errMsg: '',
        loading: true,
      }),
      FULFILLED: (state, action) => {
        const { address, billingCycle, card, canceled, currentPeriodEnd } = action.payload;

        const subscription = {
          billingCycle,
          canceled,
          currentPeriodEnd,
        };

        return {
          ...state,
          loading: false,
          address,
          card,
          subscription,
        };
      },
      REJECTED: (state, action) => {
        const response = get(action, 'payload.e.response', {});
        const errMsg = capitalize(response.data);

        return {
          ...state,
          loading: false,
          err: true,
          errMsg,
        };
      },
    },
    [RESET_STORE]: () => ({
      ...initialState,
    }),
  },
  initialState,
);
